const meridianTypes = {
  GET_MERIDIAN_CLIENTS: 'GET_MERIDIAN_CLIENTS',
  SET_MERIDIAN_CLIENTS: 'SET_MERIDIAN_CLIENTS',
  GET_MERIDIAN_CLIENT_DETAILS: 'GET_MERIDIAN_CLIENT_DETAILS',
  SET_MERIDIAN_CLIENT_DETAILS: 'SET_MERIDIAN_CLIENT_DETAILS',
  ACTIVATE_MERIDIAN_CLIENT: 'ACTIVATE_MERIDIAN_CLIENT'
};

export default meridianTypes;
